define('lq/validatorGateway',[
    'underscore'
], function (_) {

    return {

        publishEvent: function (theEvent) {
            if (!window.validator) return;
            window.validator.gateway.publishEvent(theEvent);
        },

        registerListener: function (instanceId, callback) {
            if (!window.validator) return;
            window.validator.gateway.registerListener(instanceId, callback);
        },

        unregisterListener: function (instanceId) {
            if (!window.validator) return;
            window.validator.gateway.unregisterListener(instanceId);
        }

    };

});
